import { nextTick, onMounted, ref } from 'vue';

class CommonUtil {
    numberParser = (params) => {
        return Number(params.newValue);
    };

    // VALUE FORMMATER
    partnoFormatter = (params) => {
        return params.value.replace(/(\S{5})(\S*$)/g, '$1-$2');
    };
    businessNumberFormatter = (params) => {
        const value = (params.value || '').toString();
        return value.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
    };
    phoneNumberFormatter = (params) => {
        const value = (params.value || '').toString();
        return value.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    };
    dateFormatter = (params) => {
        let val = '';
        if (params.value !== undefined) {
            val = params.value.toString().replaceAll('-', '');
        }
        return params.value === undefined ? '' : val.replace(/(\S{4})(\S{2})(\S{2})/g, '$1-$2-$3');
    };
    dateFormatter2 = (params) => {
        let val = '';
        if (params.value !== undefined) {
            val = params.value.toString().replaceAll('-', '');
        }
        return params.value === undefined ? '' : val.replace(/(\S{4})(\S{2})/g, '$1-$2');
    };

    dateTiemFormatter = (params) => {
        return params.value === undefined ? '' : params.value.replace(/(\S{4})(\S{2})(\S{2})(\S{2})/g, '$1-$2-$3 ($4시)');
    };
    //년월일 시분
    dateTiemFormatterYmdhm = (params) => {
        return params.value === undefined ? '' : params.value.replace(/(\S{4})(\S{2})(\S{2})(\S{2})(\S{2})/g, '$1-$2-$3 $4:$5');
    };
    //년월일 시분초
    dateTiemFormatterYmdhms = (params) => {
        return params.value === undefined ? '' : params.value.replace(/(\S{4})(\S{2})(\S{2})(\S{2})(\S{2})(\S{2})/g, '$1-$2-$3 $4:$5:$6');
    };

    monthFormatter = (params) => {
        const value = (params.value || '').toString();
        return value.replace(/(\S{4})(\S{2})/g, '$1-$2');
    };
    numberFormatter = (number) => {
        return Math.floor(number.value)
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    };

    numberFormatterFixed1 = (number) => {
        if (number.value === '' || number.value === null) return '';
        //Math.floor(number.value).toFixed(1).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return parseFloat(number.value)
            .toFixed(1)
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    };

    numberFormatterFixed2 = (number) => {
        if (number.value === '' || number.value === null) return '';

        //return Math.floor(number.value).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return parseFloat(number.value)
            .toFixed(2)
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    };

    numberFormatterFixed3 = (number) => {
        if (number.value === '' || number.value === null) return '';
        //return Math.floor(number.value).toFixed(3).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return parseFloat(number.value)
            .toFixed(3)
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    };

    underLineCellStyle = (params) => {
        let value = '';
        value = params.data[params.colDef.field];

        if (value !== '0' && value !== '' && value !== null) {
            return { color: 'blue', cursor: 'pointer', textDecoration: 'underline', textUnderlinePosition: 'under' };
        } else {
            return null;
        }
    };

    boldCellStyle = (params) => {
        let value = '';
        value = params.data[params.colDef.field];

        if (value !== '0' && value !== '' && value !== null) {
            return { cursor: 'pointer', fontWeight: 'bold' };
        } else {
            return null;
        }
    };

    // VALUE Getter
    partnoGetter = function (params) {
        let partnoValue = '';
        partnoValue = params.data[params.colDef.field];

        if (partnoValue.length > 5) {
            return partnoValue.replace(/((?:\S| ){5})(.*)/g, '$1-$2');
        } else {
            return partnoValue;
        }
    };

    dateGetter = function (params) {
        let dateValue = '';

        dateValue = params.data[params.colDef.field];

        return dateValue.replace(/(\S{4})(\S{2})(\S{2})/g, '$1-$2-$3');
    };

    cellValueChanged = function (params) {
        if (!params.node.selected) {
            params.node.setSelected(true);
        }
    };
    createCustomSelectEditor() {
        return {
            template: `
            <div>
                <select 
                    v-model="selectedValue" 
                    style="width:100%; height: 25px; outline: none; background-color:transparent; " 
                    @change="handleChange"
                >
                    <option value=""></option>
                    <option v-for="item in options" 
                            :key="item.id" 
                            :value="item.text"
                            :selected="isSelected(item)"
                    >
                        {{ item.text }}
                    </option>
                </select>
            </div>`,
            props: ['params'],
            data() {
                return {
                    options: this.params.values,
                    selectedValue: '',
                    currentValue: this.params.value // 현재 값 추적용 변수 추가
                };
            },
            mounted() {
                this.updateSelectedValue();
            },
            methods: {
                handleChange() {
                    const selectedOption = this.options.find((item) => item.text === this.selectedValue);
                    if (selectedOption) {
                        this.params.data[this.params.colDef.field] = selectedOption.value;
                        this.currentValue = selectedOption.value;

                        this.params.api.refreshCells({
                            rowNodes: [this.params.node],
                            columns: [this.params.column.colId],
                            force: true
                        });
                    }
                },
                isSelected(item) {
                    return item.value?.toString() === this.currentValue?.toString();
                },
                updateSelectedValue() {
                    const field = this.params.colDef.field;
                    const currentVal = this.params.data[field];
                    const option = this.options.find((item) => item.value.toString() === currentVal?.toString());
                    this.selectedValue = option?.text || '';
                    this.currentValue = currentVal;
                }
            },
            watch: {
                'params.values': {
                    // 옵션 리스트 변경 감지 추가
                    handler(newOptions) {
                        this.options = newOptions;
                        this.updateSelectedValue();
                    },
                    deep: true,
                    immediate: true
                },
                'params.data': {
                    handler(newData) {
                        if (newData[this.params.colDef.field]?.toString() !== this.currentValue?.toString()) {
                            this.updateSelectedValue();
                        }
                    },
                    deep: true,
                    immediate: true // 초기 마운트 시 즉시 실행[1][3][7]
                }
            }
        };
        // return {
        //     template: `
        //     <div>
        //     <select v-model="selectedValue" style="width:100%; height: 25px; outline: none; background-color:transparent;" @change="handleChange">
        //         <option value=""></option>
        //         <option v-for="item in options" :key="item.id" :value="item.text">
        //             {{ item.text }}
        //         </option>
        //     </select>
        // </div>
        //     `,
        //     props: ['params'],
        //     data() {
        //         return {
        //             options: this.params.values,
        //             selectedValue: ''
        //         };
        //     },
        //     mounted() {
        //         const field = this.params.colDef.field;
        //         const option = this.options.find((item) => item.value === this.params.data[field]);
        //         this.selectedValue = option ? option.text : '';
        //     },
        //     methods: {
        //         handleChange() {
        //             if (this.selectedValue === '') {
        //                 const field = this.params.colDef.field;
        //                 this.params.data[field] = '';
        //             } else {
        //                 const selectedOption = this.options.find((item) => item.text === this.selectedValue);
        //                 if (selectedOption) {
        //                     const field = this.params.colDef.field;
        //                     this.params.data[field] = selectedOption.value;
        //                 }
        //             }
        //         }
        //     },
        //     watch: {
        //         'params.data': {
        //             handler(newValue) {
        //                 const field = this.params.colDef.field;
        //                 const option = this.options.find((item) => item.value === newValue[field]);
        //                 this.selectedValue = option ? option.text : this.options[0].text;
        //             },
        //             deep: true
        //         }
        //     }
        // };
    }
    createCustomSelectEditorNonAll() {
        return {
            template: `
            <div>
                <select 
                    v-model="selectedValue" 
                    style="width:100%; height: 25px; outline: none; background-color:transparent; " 
                    @change="handleChange"
                >
                    <option v-for="item in options" 
                            :key="item.id" 
                            :value="item.text"
                            :selected="isSelected(item)"
                    >
                        {{ item.text }}
                    </option>
                </select>
            </div>`,
            props: ['params'],
            data() {
                return {
                    options: this.params.values,
                    selectedValue: '',
                    currentValue: this.params.value // 현재 값 추적용 변수 추가
                };
            },
            mounted() {
                this.updateSelectedValue();
            },
            methods: {
                handleChange() {
                    const selectedOption = this.options.find((item) => item.text === this.selectedValue);
                    if (selectedOption) {
                        this.params.data[this.params.colDef.field] = selectedOption.value;
                        this.currentValue = selectedOption.value;

                        this.params.api.refreshCells({
                            rowNodes: [this.params.node],
                            columns: [this.params.column.colId],
                            force: true
                        });
                    }
                },
                isSelected(item) {
                    return item.value?.toString() === this.currentValue?.toString();
                },
                updateSelectedValue() {
                    const field = this.params.colDef.field;
                    const currentVal = this.params.data[field];
                    const option = this.options.find((item) => item.value.toString() === currentVal?.toString());
                    this.selectedValue = option?.text || '';
                    this.currentValue = currentVal;
                }
            },
            watch: {
                'params.values': {
                    // 옵션 리스트 변경 감지 추가
                    handler(newOptions) {
                        this.options = newOptions;
                        this.updateSelectedValue();
                    },
                    deep: true,
                    immediate: true
                },
                'params.data': {
                    handler(newData) {
                        if (newData[this.params.colDef.field]?.toString() !== this.currentValue?.toString()) {
                            this.updateSelectedValue();
                        }
                    },
                    deep: true,
                    immediate: true // 초기 마운트 시 즉시 실행[1][3][7]
                }
            }
        };
    }

    dateToSeoul = function (dateString) {
        if (dateString === undefined || dateString === '') {
            return '';
        }
        // 'YYYYMMDD' 형식 처리
        if (/^\d{8}$/.test(dateString)) {
            const year = parseInt(dateString.slice(0, 4), 10);
            const month = String(parseInt(dateString.slice(4, 6), 10)).padStart(2, '0');
            const day = String(parseInt(dateString.slice(6, 8), 10)).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }

        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };
    //시분초 샘플링
    // function convertISOToKorean(dateString, type = 'minute') {
    //     if (dateString === undefined || dateString === '') {
    //         return '';
    //     }

    //     if (dateString.split(':').length > 2 && type === 'minute') {
    //         dateString = dateString.split(':').slice(0, -1).join(':');
    //     }

    //     const date = new Date(dateString);

    //     const year = date.getFullYear();
    //     const month = String(date.getMonth() + 1).padStart(2, '0');
    //     const day = date.getDate();
    //     const hour = date.getHours();
    //     const minute = date.getMinutes();

    //     return `${year}-${month}-${day}T${hour}:${minute}${type === 'second' ? ' ' + date.getSeconds() + '초' : ''}`;
    // }
    createDateInputComponent() {
        return {
            setup(props) {
                const inputRef = ref(null);
                const currentValue = ref('');

                const afterGuiAttached = () => {
                    nextTick(() => inputRef.value?.focus());
                };

                const formatDate = (val) => {
                    if (!val) return '';
                    return val.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
                };

                onMounted(() => {
                    currentValue.value = formatDate(props.params.value);
                });

                const handleKeydown = (e) => {
                    e.preventDefault();
                    e.target.showPicker();
                };

                const handleClick = (e) => {
                    e.preventDefault();
                    e.target.showPicker();
                };

                const handleChange = (event) => {
                    currentValue.value = event.target.value;
                    props.params.stopEditing();
                };

                const getValue = () => currentValue.value;

                return { currentValue, inputRef, afterGuiAttached, handleChange, getValue, handleKeydown, handleClick };
            },
            template: `
            <input
            ref="inputRef"
            v-model="currentValue"
            type="date"
            style="height:25px; width:100%; border:none; outline:none; cursor: pointer;"
            @click="handleClick"
            @keydown="handleKeydown"
            @change="handleChange"
        />
            `
        };
    }

    buttonRender = () => {
        return {
            template: `
                <div v-if="buttonLabel">
                    <button 
                        @click="buttonClicked" 
                        :style="buttonStyle"
                    >
                        {{ buttonLabel }}
                    </button>
                </div>
                
            `,
            props: ['params'],
            data() {
                return {
                    options: this.params.values || [], // 옵션 배열
                    selectedValue: '', // 선택된 값
                    buttonLabel: this.params.buttonLabel,
                    buttonStyle: {
                        color: this.params.fontColor || '#e5e7eb',
                        fontFamily: this.params.fontFamily || 'SCoreDream400',
                        fontSize: this.params.fontSize || '0.875rem',
                        backgroundColor: this.params.backgroundColor || '#0038EA',
                        // border: this.params.border || '0.1rem solid #ccc',
                        // borderRadius: this.params.borderRadius || '1rem',
                        opacity: '0.8',
                        padding: '0.8rem 0.5rem',
                        borderRadius: '1.2rem',
                        cursor: 'pointer'
                    }

                    //fontColor: this.params.fontColor || 'black'
                    //fontSize: this.params.fontSize || '0.9rem'
                };
            },
            mounted() {
                const field = this.params.colDef.field;
                const option = this.options.find((item) => item.value === this.params.data[field]);
                this.selectedValue = option ? option.text : '';
            },
            methods: {
                buttonClicked() {
                    if (this.params.onClick) {
                        this.params.onClick(this.params);
                    }
                },
                handleChange() {
                    const selectedOption = this.options.find((item) => item.text === this.selectedValue);
                    if (selectedOption) {
                        // AG Grid 데이터 업데이트
                        this.params.node.setDataValue(this.params.column.getColId(), selectedOption.value);

                        // 변경 사항 즉시 반영
                        this.params.api.refreshCells({
                            rowNodes: [this.params.node],
                            columns: [this.params.column.colId],
                            force: true
                        });

                        // 편집 모드 종료
                        this.params.api.stopEditing();
                    }
                }
            }
        };
    };
}

export default CommonUtil;
